( function( $, moment ) {
    "use strict";

    var BookingFreeArtist = {
        WINDOW_RESIZE_DELAY : 100,
        events : {}
    };

    BookingFreeArtist.events.onShow = function () {
        var $component = $(this);

        $component
            .removeClass('hidden')
            .trigger('adjust.booking-free-artist');

        $(window).on('resize.booking-free-artist', BookingFreeArtist.events.onResizeWindow);

        if (! $component.data('booking-free-artist.state')) {
            $component.trigger('fetch.booking-free-artist');
        }
    };

    BookingFreeArtist.events.onHide = function () {
        $(window).off('resize.booking-free-artist');
        $('body').css({overflow: 'auto'});
        $(this).addClass('hidden');
    };

    BookingFreeArtist.events.onAdjust = function () {
        var $component = $(this),
            $dialog = $component.find('[booking-free-artist-dialog]'),
            $header = $component.find('[booking-free-artist-header]'),
            $content = $component.find('[booking-free-artist-content]');

            $dialog.css({marginTop : '0'});
            $dialog.height('auto');
            $content.height('auto');

            if ($dialog.outerHeight() / $(window).height() > 0.8) {
                var dialogVerticalSpace = $dialog.outerHeight() - $dialog.height();

                $dialog.height($(window).height() - dialogVerticalSpace * 2);
                $content.height($dialog.height() - $header.outerHeight());
            }

            var marginTop = ($(window).height() - $dialog.outerHeight()) / 2;
            $dialog.css({marginTop : marginTop+'px'});

            $('body').css({overflow: 'hidden'});
    };

    BookingFreeArtist.events.onFetch = function () {
        var $component = $(this),
            $title = $component.find('[booking-free-artist-title]'),
            $content = $component.find('[booking-free-artist-content]'),
            bookingId = $component.data('booking-id');

        $component.addClass('loading').data('booking-free-artist.state', 'loading')

        $.App.api('GET', 'bookings/'+bookingId+'/free-artists', {active : true})
            .done(function(response) {
                if (! response.success) return;

                $title.html(response.title);
                $content.html(response.content);

                $component.data('booking-free-artist.state', 'loaded');

                if ($component.is(':visible')) {
                    $component.trigger('adjust.booking-free-artist');
                }
            })
            .always(function() {
                $component.removeClass('loading');
            });
    };

    BookingFreeArtist.events.onClickShow = function () {
        var $show = $(this),
            $component = $('[booking-free-artist="'+$show.attr('booking-free-artist-show')+'"]');

        $component
            .data('booking-id', $show.data('booking-id'))
            .trigger('show.booking-free-artist');
    };

    BookingFreeArtist.events.onClickHide = function () {
        $(this).closest('[booking-free-artist]').trigger('hide.booking-free-artist');
    };

    BookingFreeArtist.events.onSelectArtist = function () {
        var $choice = $(this),
            $select = $('#booking_artist_artist'),
            $component = $choice.closest('[booking-free-artist]');

        if (! $choice.prop('checked')) return;

        $select.data('selectize').setValue($choice.val());
        $select.closest('form').trigger('submit');

        $component.trigger('hide.booking-free-artist');
    };

    BookingFreeArtist.events.onResizeWindow = function () {
        var $window = $(this);

        clearTimeout($window.data('booking-free-artist.resize-timeout'));

        $window.data('booking-free-artist.resize-timeout', setTimeout(function () {
            $('[booking-free-artist]').trigger('adjust.booking-free-artist');
        }, BookingFreeArtist.WINDOW_RESIZE_DELAY));
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $show = $('[booking-free-artist-show]'),
            $component = $container.find('[booking-free-artist]'),
            $hide = $component.find('[booking-free-artist-hide]'),
            $overlay = $component.find('[booking-free-artist-overlay]'),
            choiceSelector = 'input[type="checkbox"][booking-free-artist-choice]';

        $component
            .on('show.booking-free-artist', BookingFreeArtist.events.onShow)
            .on('hide.booking-free-artist', BookingFreeArtist.events.onHide)
            .on('fetch.booking-free-artist', BookingFreeArtist.events.onFetch)
            .on('adjust.booking-free-artist', BookingFreeArtist.events.onAdjust)
            .on('click.booking-free-artist', choiceSelector, BookingFreeArtist.events.onSelectArtist);

        $show.on('click.booking-free-artist', BookingFreeArtist.events.onClickShow);
        $hide.on('click.booking-free-artist', BookingFreeArtist.events.onClickHide);
        $overlay.on('click.booking-free-artist', BookingFreeArtist.events.onClickHide);
    });

} ( require('jquery') ) );
